import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Column } from '~/commonComponents/Column';
import { EmptyFavoriteProfessionalCopy } from '~/components/ProfessionalsHub/Constants';

export const NoFavorite = () => {
  return (
    <Column alignItems="center">
      <EmptyFavoriteProfessionalCopy.Icon size={136} />

      <Typography as="span" bold color={colors.neutral[500]} size="heading_4" style={{ marginTop: 18 }}>
        {EmptyFavoriteProfessionalCopy.title}
      </Typography>
      <Column width="95%" gap={16} marginTop={18}>
        <Typography as="span" color={colors.neutral[500]}>{EmptyFavoriteProfessionalCopy.description}</Typography>
        <ul
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 24,
            marginLeft: -20,
            marginTop: 20,
          }}
        >
          {EmptyFavoriteProfessionalCopy.steps.map(({ description, title }) => (
            <li key={title}>
              <Typography as="span" bold color={colors.neutral[500]}>
                {title}
              </Typography>{' '}
              <Typography as="span" color={colors.neutral[500]}>{description}</Typography>
            </li>
          ))}
        </ul>
      </Column>
    </Column>
  );
};
